import { useRequest } from 'umi';
import { Api } from '@/api';

type TConfigKeys = 'tips.suggest';

export default () => {
  const { data } = useRequest(Api.store.storeControllerV4.getConfig, {
    formatResult(res) {
      return res?.data?.configs?.reduce((acc, cur) => {
        return { ...acc, [cur.configKey!]: cur.configValue };
      }, {});
    },
  });

  return {
    config: data as Record<TConfigKeys, any>,
  };
};
